import React, { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import useProductItem from "../../components/ProductItem/useProductItem";
import HeaderBack from "../../../helbest/HeaderBack/HeaderBack";
import { Button, Card } from "antd";
import { useProductQuery } from "../../../saleor/api";
import { displayRichText, Comma } from "../../../base/utils";
import { Note, Page, Uniter } from "../../../helbest";
import { ReactComponent as OutOfStock } from "../../../assets/svg/out-of-stock.svg";
import { ProductTransformer } from "../../../services/objectTransformer/products";
import { getCountryIsoFromCountryName } from "../../../base/utils";
import Loading from "../../components/Loading/Loading";
import { useLangNavigate } from "../../../hooks/useLangNavigate";
import { useSelector } from "react-redux";
import { channelDetails } from "../../../base/env";

function ProductDetails() {
  const { t, i18n } = useTranslation();
  const [rawProduct, setRawProduct] = useState(null);
  const { id } = useParams();
  const navigate = useLangNavigate();
  const { add_to_cart, addLoading } = useProductItem();
  const historyLength = window.history.length;
  const { channel, country_name } = useSelector((state) => state.Login);
  const countryIso = getCountryIsoFromCountryName(country_name);

  const { loading } = useProductQuery({
    variables: {
      id: id,
      channel,
      lng: i18n.language.toUpperCase(),
    },
    onCompleted(response) {
      setRawProduct(response.product);
    },
    onError(error) {
      navigate("/");
      Note.error(error.message);
    },
  });


  const data = ProductTransformer(rawProduct, i18n.language, countryIso);

  const onClick = () => {
    if (data) {
      add_to_cart(data);
    }
  };

  const precision = channelDetails[channel].precision;
  const currency = channelDetails[channel].currency;
  const savingAmount = data
    ? (data.price - data.payable_amount).toFixed(precision)
    : 0;

  return (
    <>
      <Page
        className="bg-gray-light page-delivery"
        footer={
          <Footer
            clickHandler={onClick}
            disabled={loading || !data || data.quantityAvailable === 0}
            addLoading={addLoading}
          />
        }
        showFooter
        customHeader={
          <HeaderBack
            title={t("common.details")}
            url={historyLength <= 2 ? "/" : undefined}
          />
        }
        headerFix
      >
        {loading && (
          <div className="mt-5 text-center">
            <Loading />
          </div>
        )}
        {data && (
          <div className="detail-container">
            <div className="product-detail-p-img mt-5 mb-4">
              <img
                className="product-detail-img"
                loading="lazy"
                src={data.image}
                alt={data.name}
              />
              {data.quantityAvailable === 0 && (
                <OutOfStock className="out-of-stock" />
              )}
            </div>
            <div className="product-detail-body">
              <div className="product-detail-data">
                <span className="product-detail-data-title">{data.name}</span>

                <div className="price-discount-container">
                  <div className="product-detail-data-price-container">
                    {data.payable_amount !== data.price && (
                      <Uniter
                        className="product-detail-data-price-discount"
                        childSize={16}
                      >
                        {data.price}
                      </Uniter>
                    )}
                    <Uniter isBold childSize={16}>
                      {data.payable_amount}
                    </Uniter>
                  </div>

                  {savingAmount > 0 && (
                    <div className="product-detail-data-discount-container">
                      <span className="discount">
                        <span>{t("common.saving")}</span>
                        <Uniter className="saving-amount-color" isBold>{Comma(savingAmount)}</Uniter>
                      </span>
                    </div>
                  )}
                </div>


                {/* <div className="product-detail-data-stock">
                  {data.quantityAvailable === 0 ? (
                    <span>{t("cart.out_of_stock")}</span>
                  ) : (
                    <>
                      <span>{t("cart.stock_available")}</span>
                      <span> {data.quantityAvailable}</span>
                    </>
                  )}
                </div> */}
              </div>
            </div>
            <React.Fragment>
              {data.aboutTheseItems && (
                <div
                  className="product-list-header reletive text-right"
                  style={{
                    maxWidth: "500px",
                    padding: " 0 var(--hig-size-1)",
                    width: "100%",
                    marginTop: "12px",
                  }}
                >
                  <div className="w-full detail-section-title">
                    <div className="detail-section-title-text">
                      {data.aboutTheseItems.title}
                    </div>
                  </div>
                  <div className="detail-item-icons">
                    {data.aboutTheseItems.details?.map((detail, index) => (
                      <Card key={index}>
                        <div className="detail-prod-box hide-border-bottom">
                          {detail.inputType === "RICH_TEXT" ? (
                            <div
                              className="detail-services"
                              dangerouslySetInnerHTML={displayRichText(
                                detail.richText,
                              )}
                            />
                          ) : (
                            <p className="detail-services">{detail.name}</p>
                          )}
                        </div>
                      </Card>
                    ))}
                  </div>
                </div>
              )}
            </React.Fragment>

          </div>
        )}
      </Page>
    </>
  );
}

function Footer({ disabled, clickHandler, addLoading }) {
  const { t } = useTranslation();
  return (
    <div className="page-fixed-footer-container">
      <Button
        type="primary"
        size="large"
        style={{
          width: "100%",
        }}
        loading={addLoading}
        onClick={clickHandler}
        disabled={disabled}
      >
        {t("home.detail.add")}
      </Button>
    </div>
  );
}

export default ProductDetails;